<!-- Page Banner -->
<div class="page-banner-area item-bg4">
    <div class="container">
        <div class="page-banner-content">
            <h2>Careers</h2>
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>Careers</li>
            </ul>
        </div>
    </div>
</div>

<!-- Industries -->
<section class="industries-area pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <h2>Take a look at our job offerings</h2>
            <div class="bar"></div>
        </div>

    </div>
</section>
<!-- Services -->
<section class="services-area bg-fafafa pt-100 pb-70">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6" *ngFor="let job of jobs">
                <div class="single-services-item">
                    <div class="image">
                        <a [routerLink]="['/jobdetails', job.id]">
                            <img src="assets/img/services/services-{{13-job.id}}.jpg" alt="image">
                        </a>
                    </div>
                    <div class="content">
                        <h3><a [routerLink]="['/jobdetails', job.id]">{{job.title}}</a></h3>
                        <span>{{job.location.locationName}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="default-shape">
        <div class="shape1"><img src="assets/img/default-shape/default-shape1.png" alt="image"></div>
        <div class="shape2"><img src="assets/img/default-shape/default-shape2.png" alt="image"></div>
        <div class="shape3"><img src="assets/img/default-shape/default-shape3.png" alt="image"></div>
        <div class="shape4"><img src="assets/img/default-shape/default-shape4.png" alt="image"></div>
    </div>
</section>
<!-- End Services -->